import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-10 md:pt-16 md:pb-14 overflow-hidden" data-id="element-105">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-grid-pattern z-0" data-id="element-106"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-500/10 rounded-full blur-[120px] z-0 pointer-events-none" data-id="element-107"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-108">
        <div className="text-center max-w-4xl mx-auto mb-12" data-id="element-109">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-cyan-500/30 bg-cyan-500/10 text-cyan-400 text-sm font-medium mb-5 tracking-wider uppercase" data-id="element-110">
            <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" data-id="element-111"></span>
            System Online
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 leading-tight" data-id="element-112">
            FROM 60-HOUR CORPORATE GRIND TO A 4-HOUR{' '}
            <br className="hidden md:block" data-id="element-113" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600 text-glow" data-id="element-114">
              "GHOST FACTORY"
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-400 mb-6 font-light" data-id="element-115">
            That Generates $10,000/Month.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-116">
            <a href="#checkout" onClick={e => {
            e.preventDefault();
            document.getElementById('checkout')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-black bg-cyan-400 rounded-sm overflow-hidden transition-all hover:bg-cyan-300 hover:shadow-[0_0_30px_rgba(0,240,255,0.5)]" data-id="element-117">
              <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-56 group-hover:h-56 opacity-10" data-id="element-118"></span>
              <span className="relative flex items-center gap-2" data-id="element-119">
                INITIALIZE ENGINE <ChevronRightIcon className="w-5 h-5" data-id="element-120" />
              </span>
            </a>
            <p className="text-sm text-gray-500 mt-4 sm:mt-0 sm:ml-4" data-id="element-121">
              Instant Access
            </p>
          </div>
        </div>

        <div className="relative max-w-4xl mx-auto mt-10" data-id="element-122">
          <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-xl blur opacity-30 animate-pulse" data-id="element-123"></div>
          <div className="relative rounded-xl overflow-hidden border border-cyan-500/20 bg-dark-900 p-2 shadow-2xl" data-id="element-124">
            <img src="https://cdn.magicpatterns.com/uploads/rkyG2UTAdxpsg9UVRM7F7u/THE_10K_IA_CONTENT.png" alt="The $10K AI Content Engine Product" className="w-full h-auto rounded-lg object-cover" data-id="element-125" />
            {/* Overlay gradient to blend image slightly */}
            <div className="absolute inset-0 bg-gradient-to-t from-dark-900/80 via-transparent to-transparent pointer-events-none" data-id="element-126"></div>
          </div>
        </div>
      </div>
    </section>;
}